// // import React from "react";
// // import { FiShoppingCart } from "react-icons/fi";
// // import { formatMoneyByLanguage } from "../../helpers/money";

// // const MAIN_COLOR = "rgb(29, 71, 127)";

// // const ProductCard = ({
// //   product,
// //   quantity = 0,
// //   onChangeQuantity,
// //   language = "tr",
// // }) => {
// //   const unitPrice = Number(product?.unitPrice ?? 0);

// //   const langKey = String(language || "tr")
// //     .toLowerCase()
// //     .replace("_", "-")
// //     .trim()
// //     .slice(0, 2);

// //   return (
// //     <div className="flex h-full flex-col overflow-hidden rounded-xl border border-slate-300 bg-white shadow-sm transition duration-200 hover:-translate-y-[1px] hover:shadow-md">
// //       <div className="flex h-[120px] items-center justify-center bg-[#efefef] p-3 sm:h-[135px] lg:h-[145px]">
// //         {product?.image ? (
// //           <img
// //             src={product.image}
// //             alt={product?.name || ""}
// //             className="max-h-[78px] max-w-[78px] object-contain sm:max-h-[88px] sm:max-w-[88px] lg:max-h-[95px] lg:max-w-[95px]"
// //           />
// //         ) : (
// //           <div className="flex h-12 w-12 items-center justify-center rounded-full bg-white text-slate-500 shadow-sm" />
// //         )}
// //       </div>

// //       <div className="px-3 pt-3 pb-2 text-[13px] leading-5 text-slate-800 sm:text-[14px]">
// //         <div className="line-clamp-2 min-h-[40px] sm:min-h-[44px]">
// //           {product?.name || ""}
// //         </div>
// //       </div>

// //       <div
// //         className="mt-auto px-3 py-2 text-white"
// //         style={{ backgroundColor: MAIN_COLOR }}
// //       >
// //         <div className="text-right text-[13px] font-bold">
// //           {formatMoneyByLanguage(unitPrice, langKey)}
// //         </div>
// //       </div>

// //       <div className="px-2 py-2" style={{ backgroundColor: MAIN_COLOR }}>
// //         <div className="flex h-9 w-full overflow-hidden rounded-md border border-white/20 bg-white/10 text-white">
// //           <button
// //             type="button"
// //             onClick={() => onChangeQuantity(product, "decrease")}
// //             className="flex w-10 items-center justify-center text-lg font-bold transition hover:bg-white/20"
// //           >
// //             -
// //           </button>

// //           <div className="flex flex-1 items-center justify-center border-x border-white/20">
// //             {quantity > 0 ? (
// //               <span className="text-sm font-semibold">{quantity}</span>
// //             ) : (
// //               <FiShoppingCart size={15} />
// //             )}
// //           </div>

// //           <button
// //             type="button"
// //             onClick={() => onChangeQuantity(product, "increase")}
// //             className="flex w-10 items-center justify-center text-lg font-bold transition hover:bg-white/20"
// //           >
// //             +
// //           </button>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default ProductCard;
// import React from "react";
// import { FiShoppingCart } from "react-icons/fi";
// import { formatMoneyByLanguage } from "../../helpers/money";

// const MAIN_COLOR = "rgb(29, 71, 127)";

// const ProductCard = ({
//   product,
//   quantity = 0,
//   onChangeQuantity,
//   language = "tr",
// }) => {
//   const unitPrice = Number(product?.unitPrice ?? 0);

//   const langKey = String(language || "tr")
//     .toLowerCase()
//     .replace("_", "-")
//     .trim()
//     .slice(0, 2);

//   const priceType = product?.priceType;
//   const provisioning = product?.provisioningSetting || {};

//   const priceTypeLabel =
//     priceType === "AM"
//       ? "Aylık Abonelik"
//       : priceType === "AY"
//         ? "Yıllık Abonelik"
//         : priceType === "Q"
//           ? "Kontör Paketi"
//           : "";

//   const monthCount = provisioning?.subscriptionNumberOfMonth;
//   const monthlyGiftCredit = provisioning?.monthlyGiftCredit;
//   const credit = provisioning?.credit;
//   const creditType = provisioning?.creditType;

//   return (
//     <div className="flex h-full flex-col overflow-hidden rounded-xl border border-slate-300 bg-white shadow-sm transition duration-200 hover:-translate-y-[1px] hover:shadow-md">
//       <div className="flex h-[105px] items-center justify-center bg-[#efefef] p-3 sm:h-[115px] lg:h-[125px]">
//         {product?.image ? (
//           <img
//             src={product.image}
//             alt={product?.name || ""}
//             className="max-h-[76px] max-w-[76px] object-contain sm:max-h-[84px] sm:max-w-[84px] lg:max-h-[90px] lg:max-w-[90px]"
//           />
//         ) : (
//           <div className="flex h-12 w-12 items-center justify-center rounded-full bg-white text-slate-500 shadow-sm" />
//         )}
//       </div>

//       <div className="px-3 pt-3 pb-2 text-[13px] leading-5 text-slate-800 sm:text-[14px]">
//         <div className="line-clamp-2 min-h-[40px] sm:min-h-[44px]">
//           {product?.name || ""}
//         </div>

//         <div className="mt-2 flex flex-wrap gap-1.5">
//           {priceTypeLabel && (
//             <span className="rounded-full bg-slate-100 px-2 py-1 text-[11px] font-semibold text-slate-700">
//               {priceTypeLabel}
//             </span>
//           )}

//           {monthCount && (
//             <span className="rounded-full bg-blue-50 px-2 py-1 text-[11px] font-semibold text-blue-700">
//               {monthCount} Ay
//             </span>
//           )}

//           {monthlyGiftCredit && (
//             <span className="rounded-full bg-emerald-50 px-2 py-1 text-[11px] font-semibold text-emerald-700">
//               Aylık {monthlyGiftCredit} Kontör
//             </span>
//           )}

//           {credit && (
//             <span className="rounded-full bg-amber-50 px-2 py-1 text-[11px] font-semibold text-amber-700">
//               {credit} Kontör
//             </span>
//           )}

//           {creditType && (
//             <span className="rounded-full bg-purple-50 px-2 py-1 text-[11px] font-semibold text-purple-700">
//               Tip: {creditType}
//             </span>
//           )}
//         </div>
//       </div>

//       <div
//         className="mt-auto px-3 py-2 text-white"
//         style={{ backgroundColor: MAIN_COLOR }}
//       >
//         <div className="text-right text-[13px] font-bold">
//           {formatMoneyByLanguage(unitPrice, langKey)}
//         </div>
//       </div>

//       <div className="px-2 py-2" style={{ backgroundColor: MAIN_COLOR }}>
//         <div className="flex h-9 w-full overflow-hidden rounded-md border border-white/20 bg-white/10 text-white">
//           <button
//             type="button"
//             onClick={() => onChangeQuantity(product, "decrease")}
//             className="flex w-10 items-center justify-center text-lg font-bold transition hover:bg-white/20"
//           >
//             -
//           </button>

//           <div className="flex flex-1 items-center justify-center border-x border-white/20">
//             {quantity > 0 ? (
//               <span className="text-sm font-semibold">{quantity}</span>
//             ) : (
//               <FiShoppingCart size={15} />
//             )}
//           </div>

//           <button
//             type="button"
//             onClick={() => onChangeQuantity(product, "increase")}
//             className="flex w-10 items-center justify-center text-lg font-bold transition hover:bg-white/20"
//           >
//             +
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProductCard;import React from "react";
import { FiShoppingCart, FiCheckCircle } from "react-icons/fi";
import { formatMoneyByLanguage } from "../../helpers/money";

const MAIN_COLOR = "rgb(29, 71, 127)";

const TEXTS = {
  tr: {
    monthlySubscription: "Aylık Abonelik",
    yearlySubscription: "Yıllık Abonelik",
    monthlyCredit: "Kontör / Ay",
    ioCredit: "Giden ve Gelen Fatura Kontörü",
    outgoingCredit: "Giden Fatura Kontörü",
    unlimitedIncoming: "Gelen Faturalar Sınırsız",
    selectPackage: "Paketi Seç",
    selected: "Seçildi",
    perCompany: "Firma başına:",
    companyFor: "Firma için:",
    infoTooltip:
      "Kullanılan paket dahilinde hediye edilen kontörler aynı ay içerisinde kullanılır.\nHer işletme için ayrı paket alınması gerekmektedir.\nStandart boyutu aşan faturalar için ilave kontör kullanılabilir.\nSatın alınan kontörlerin son kullanım tarihi yoktur.",
  },
  en: {
    monthlySubscription: "Monthly Subscription",
    yearlySubscription: "Yearly Subscription",
    monthlyCredit: "Credits / Month",
    ioCredit: "Outgoing and Incoming Invoice Credits",
    outgoingCredit: "Outgoing Invoice Credits",
    unlimitedIncoming: "Unlimited Incoming Invoices",
    selectPackage: "Select Package",
    selected: "Selected",
    perCompany: "Per company:",
    companyFor: "Companies:",
    infoTooltip:
      "The free credits included in the package must be used within the same month. Unused credits cannot be carried over to the following months.\nA separate package must be purchased for each company.\nAdditional credits may be used for invoices exceeding the standard size.\nPurchased credits do not have an expiration date.",
  },
  de: {
    monthlySubscription: "Monatliches Abonnement",
    yearlySubscription: "Jahresabonnement",
    monthlyCredit: "Kontingent / Monat",
    ioCredit: "Kontingent für ausgehende und eingehende Rechnungen",
    outgoingCredit: "Kontingent für ausgehende Rechnungen",
    unlimitedIncoming: "Eingehende Rechnungen unbegrenzt",
    selectPackage: "Paket wählen",
    selected: "Ausgewählt",
    perCompany: "Pro Firma:",
    companyFor: "Firmen:",
    infoTooltip:
      "Die im Paket enthaltenen Gratis-Kontingente müssen im selben Monat verwendet werden. Nicht genutzte Kontingente können nicht in die Folgemonate übertragen werden.\nFür jedes Unternehmen muss ein separates Paket erworben werden.\nFür Rechnungen, die die Standardgröße überschreiten, können zusätzliche Kontingente verwendet werden.\nGekaufte Kontingente haben kein Ablaufdatum.",
  },
  fr: {
    monthlySubscription: "Abonnement mensuel",
    yearlySubscription: "Abonnement annuel",
    monthlyCredit: "Crédits / Mois",
    ioCredit: "Crédits pour factures entrantes et sortantes",
    outgoingCredit: "Crédits pour factures sortantes",
    unlimitedIncoming: "Factures entrantes illimitées",
    selectPackage: "Sélectionner",
    selected: "Sélectionné",
    perCompany: "Par entreprise :",
    companyFor: "Entreprises :",
    infoTooltip:
      "Les crédits offerts inclus dans le forfait doivent être utilisés dans le même mois. Les crédits non utilisés ne peuvent pas être reportés.\nUn forfait distinct doit être acheté pour chaque entreprise.\nDes crédits supplémentaires peuvent être utilisés pour les factures dépassant la taille standard.\nLes crédits achetés n'ont pas de date d'expiration.",
  },
  nl: {
    monthlySubscription: "Maandelijks abonnement",
    yearlySubscription: "Jaarabonnement",
    monthlyCredit: "Credits / Maand",
    ioCredit: "Credits voor inkomende en uitgaande facturen",
    outgoingCredit: "Credits voor uitgaande facturen",
    unlimitedIncoming: "Onbeperkte inkomende facturen",
    selectPackage: "Pakket kiezen",
    selected: "Geselecteerd",
    perCompany: "Per bedrijf:",
    companyFor: "Bedrijven:",
    infoTooltip:
      "De gratis credits die bij het pakket zijn inbegrepen, moeten binnen dezelfde maand worden gebruikt. Ongebruikte credits kunnen niet worden meegenomen naar volgende maanden.\nVoor elk bedrijf moet een afzonderlijk pakket worden aangeschaft.\nVoor facturen die groter zijn dan de standaardgrootte kunnen extra credits worden gebruikt.\nGekochte credits hebben geen vervaldatum.",
  },
};

const ProductCard = ({
  product,
  quantity = 0,
  onChangeQuantity,
  language = "tr",
}) => {
  const unitPrice = Number(product?.unitPrice ?? 0);
  const multiplier = Number(product?.multiplier ?? 1);
  const totalPrice = unitPrice * multiplier;

  const langKey = String(language || "tr")
    .toLowerCase()
    .replace("_", "-")
    .trim()
    .slice(0, 2);

  const text = TEXTS[langKey] || TEXTS.tr;

  const priceType = product?.priceType;
  const provisioning = product?.provisioningSetting || {};

  const isSubscription = priceType === "AM" || priceType === "AY";
  const isSelected = isSubscription && quantity > 0;

  const monthlyGiftCredit = provisioning?.monthlyGiftCredit;
  const creditType = provisioning?.creditType;

  const monthlyCreditTotal =
    Number(monthlyGiftCredit || 0) * Number(multiplier || 1);

  const getSubscriptionTitle = () => {
    const productName = product?.name || "";

    if (productName.includes("(Basic)")) return "Basic";
    if (productName.includes("(Starter)")) return "Starter";
    if (productName.includes("(Standard)")) return "Standard";
    if (productName.includes("(Premium)")) return "Premium";

    return productName;
  };

  return (
    <div
      className={[
        "relative flex h-full flex-col rounded-xl bg-white transition duration-200",
        isSelected
          ? "border-[2px] border-[#1d477f] shadow-lg"
          : "border border-slate-300 shadow-sm hover:-translate-y-[1px] hover:shadow-md",
      ].join(" ")}
    >
      <div className="absolute right-3 top-3 z-20 group">
        <div
          className="flex h-6 w-6 cursor-help items-center justify-center rounded-full border text-xs font-bold transition-all duration-200 hover:scale-110"
          style={{
            borderColor: "#6b7280",
            color: "#6b7280",
            backgroundColor: "#e5e7eb",
          }}
        >
          i
        </div>

        <div className="pointer-events-none absolute right-0 top-8 z-[9999] hidden w-[210px] rounded-xl bg-white p-3 text-[11px] leading-5 text-slate-700 shadow-xl ring-1 ring-slate-200 group-hover:block">
          {text.infoTooltip.split("\n").map((line, index) => (
            <div key={index} className="mb-1 flex items-start gap-1 last:mb-0">
              <span className="shrink-0">•</span>
              <span className="break-words">{line}</span>
            </div>
          ))}
        </div>
      </div>

      {priceType === "Q" && (
        <div className="flex h-[120px] items-center justify-center rounded-t-xl bg-[#efefef] p-3 sm:h-[135px] lg:h-[145px]">
          {product?.image ? (
            <img
              src={product.image}
              alt={product?.name || ""}
              className="max-h-[78px] max-w-[78px] object-contain sm:max-h-[88px] sm:max-w-[88px] lg:max-h-[95px] lg:max-w-[95px]"
            />
          ) : (
            <div className="flex h-12 w-12 items-center justify-center rounded-full bg-white text-slate-500 shadow-sm">
              <FiShoppingCart size={18} />
            </div>
          )}
        </div>
      )}

      <div className="flex-1 px-4 pt-4 pb-3 text-[13px] leading-5 text-slate-800 sm:text-[14px]">
        {isSubscription ? (
          <>
            <div className="pr-8 text-xl font-bold" style={{ color: MAIN_COLOR }}>
              {getSubscriptionTitle()}
            </div>

            {monthlyGiftCredit && (
              <div
                className="mt-4 text-[15px] font-bold"
                style={{ color: MAIN_COLOR }}
              >
                {monthlyCreditTotal} {text.monthlyCredit}
              </div>
            )}

            {creditType === "IO" && (
              <div className="mt-2 text-[15px] font-bold leading-5 text-slate-500">
                {text.ioCredit}
              </div>
            )}

            {creditType === "O" && (
              <div className="mt-2 text-[15px] font-bold leading-5">
                <div className="text-slate-500">{text.outgoingCredit}</div>
                <div style={{ color: MAIN_COLOR }}>
                  {text.unlimitedIncoming}
                </div>
              </div>
            )}

            <div className="mt-3 text-xs font-semibold text-slate-500">
              {priceType === "AM"
                ? text.monthlySubscription
                : text.yearlySubscription}
            </div>
          </>
        ) : (
          <div className="line-clamp-3 min-h-[60px] pr-8 font-semibold">
            {product?.name || ""}
          </div>
        )}
      </div>

      <div
        className="mt-auto px-3 py-2 text-white"
        style={{ backgroundColor: MAIN_COLOR }}
      >
        {isSubscription && multiplier > 1 ? (
          <div className="space-y-1 text-[12px] font-bold">
            <div className="flex items-center justify-between">
              <span>{text.perCompany}</span>
              <span>{formatMoneyByLanguage(unitPrice, langKey)}</span>
            </div>

            <div className="flex items-center justify-between">
              <span>
                {multiplier} {text.companyFor}
              </span>
              <span>{formatMoneyByLanguage(totalPrice, langKey)}</span>
            </div>
          </div>
        ) : (
          <div className="text-right text-[13px] font-bold">
            {formatMoneyByLanguage(totalPrice, langKey)}
          </div>
        )}
      </div>

      <div
        className="rounded-b-xl px-2 py-2"
        style={{ backgroundColor: MAIN_COLOR }}
      >
        {isSubscription ? (
          <button
            type="button"
            onClick={() =>
              onChangeQuantity(product, isSelected ? "decrease" : "increase")
            }
            className={[
              "flex h-9 w-full items-center justify-center gap-2 rounded-md border text-sm font-semibold transition",
              isSelected
                ? "border-white bg-white text-[#1d477f]"
                : "border-white/20 bg-white/10 text-white hover:bg-white/20",
            ].join(" ")}
          >
            {isSelected ? (
              <>
                <FiCheckCircle size={15} />
                {text.selected}
              </>
            ) : (
              <>
                <FiShoppingCart size={15} />
                {text.selectPackage}
              </>
            )}
          </button>
        ) : (
          <div className="flex h-9 w-full overflow-hidden rounded-md border border-white/20 bg-white/10 text-white">
            <button
              type="button"
              onClick={() => onChangeQuantity(product, "decrease")}
              className="flex w-10 items-center justify-center text-lg font-bold transition hover:bg-white/20"
            >
              -
            </button>

            <div className="flex flex-1 items-center justify-center border-x border-white/20">
              {quantity > 0 ? (
                <span className="text-sm font-semibold">{quantity}</span>
              ) : (
                <FiShoppingCart size={15} />
              )}
            </div>

            <button
              type="button"
              onClick={() => onChangeQuantity(product, "increase")}
              className="flex w-10 items-center justify-center text-lg font-bold transition hover:bg-white/20"
            >
              +
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductCard;